







































































































import { Component, Prop, Vue } from "vue-property-decorator";
import API from "../store/api";
import router from "../router";

@Component({
  components: {}
})
export default class ResetPasswordView extends Vue {
  password: string = "";
  confirmation: string = "";
  enterPassword: boolean = false;
  sent: boolean = false;
  delivered: boolean = false;
  error: boolean = false;
  matchingIssue: boolean = false;

  acknowledgeSent(): void {
    this.sent = false;
  }

  acknowledgeEnterPassword(): void {
    this.enterPassword = false;
  }

  acknowledgeError(): void {
    this.error = false;
  }

  acknowledgeMatchingIssue(): void {
    this.matchingIssue = false;
  }

  redirectToLogin(): void {
    this.$router.push({ name: "login" });
  }

  async sendPasswordResetRequest(): Promise<void> {
    if (this.password == "") {
      // if the user has not entered a password
      this.enterPassword = true;
    } else if (this.password !== this.confirmation) {
      // if the password and the password confirmation do not match
      // (example: "myCoolPassword" and "myCoolPasswrod")
      this.matchingIssue = true;
    } else {
      // let the user know that their request is being processed
      this.sent = true;

      // send the request
      const responseOK: boolean = await API.resetPasswordRequest(this.$route.params.token, this.password);

      // let the user know what happened
      this.delivered = responseOK;
      this.error = !responseOK;
      this.sent = false;
    }
  }
}
